import {rootPaths} from './rootPaths'

import Main from '../../components/main/Main'
import PrivacyPolicy from "../../components/privacy-policy/PrivacyPolicy";

export const rootRoutes = [
  {path: rootPaths.INDEX, element: Main},
  {path: rootPaths.PRIVACY_POLICY, element: PrivacyPolicy}
]
